import { Home } from '@fullstory/proto/fs/services/dx-objects';
import { createRequestReducer, DispatchedAction, RequestActionType } from '@fullstory/redux-util';
import { HomeRequestActions } from './actions';
import { HomeRequestTypes } from './types';
import { AppBackendRequestActions, AppBackendRequestTypes } from '../appbackend';
import { combineReducers } from 'redux';
import { int64 } from '@fullstory/proto/google/protobuf';

const homeRequest = createRequestReducer<Home>()(
  HomeRequestTypes.GetHomeRequest,
  HomeRequestTypes.GetHomeSuccess,
  HomeRequestTypes.GetHomeFailure,
);

type State = ReturnType<typeof homeRequest>;

const defaultState: State = {
  lastRequested: -1,
  lastResponded: -1,
  loading: false,
  error: false,
  data: { sections: [] },
  safeMessage: null,
};

type homeAction =
  | RequestActionType<typeof AppBackendRequestActions.getHomeView>
  | RequestActionType<typeof HomeRequestActions.setHome>
  | RequestActionType<typeof HomeRequestActions.createHomeSection>
  | RequestActionType<typeof HomeRequestActions.setHomeSection>
  | RequestActionType<typeof HomeRequestActions.deleteHomeSection>
  | RequestActionType<typeof HomeRequestActions.setSectionOrder>
  | RequestActionType<typeof HomeRequestActions.setHomeCard>
  | RequestActionType<typeof HomeRequestActions.duplicateHomeCard>
  | RequestActionType<typeof HomeRequestActions.deleteHomeCard>
  | DispatchedAction<
      HomeRequestTypes.GetHomeRequest,
      HomeRequestTypes.GetHomeSuccess,
      HomeRequestTypes.GetHomeFailure,
      {},
      Home
    >;

const home = (state = defaultState, action: homeAction): State => {
  switch (action.type) {
    case HomeRequestTypes.SetHomeSuccess:
    case HomeRequestTypes.CreateHomeSectionSuccess:
    case HomeRequestTypes.SetHomeSectionSuccess:
    case HomeRequestTypes.DeleteHomeSectionSuccess:
    case HomeRequestTypes.SetSectionOrderSuccess:
    case HomeRequestTypes.SetHomeCardSuccess:
    case HomeRequestTypes.DeleteHomeCardSuccess:
      return {
        ...state,
        data: action.data,
        safeMessage: null,
      };
    case AppBackendRequestTypes.GetHomeViewSuccess:
      return {
        ...state,
        data: action.data.home,
        safeMessage: null,
      };
    case HomeRequestTypes.DuplicateHomeCardSuccess:
      return {
        ...state,
        data: action.data.home,
        safeMessage: null,
      };
    case HomeRequestTypes.GetHomeRequest:
    case HomeRequestTypes.GetHomeSuccess:
    case HomeRequestTypes.GetHomeFailure:
      return homeRequest(state, action);
  }
  return state;
};

const lastSetHomeSection = createRequestReducer<Home>()(
  HomeRequestTypes.SetHomeSectionRequest,
  HomeRequestTypes.SetHomeSectionSuccess,
  HomeRequestTypes.SetHomeSectionFailure,
);

const lastSetHomeCard = createRequestReducer<Home>()(
  HomeRequestTypes.SetHomeCardRequest,
  HomeRequestTypes.SetHomeCardSuccess,
  HomeRequestTypes.SetHomeCardFailure,
);

const cardLimit = (state: number | null = null, action: homeAction): number | null => {
  switch (action.type) {
    case AppBackendRequestTypes.GetHomeViewSuccess:
      return int64.toNumber(action.data.cardLimit);
  }
  return state;
};

type HomeReducerState = {
  home: ReturnType<typeof home>;
  cardLimit: ReturnType<typeof cardLimit>;
  lastSetHomeSection: ReturnType<typeof lastSetHomeSection>;
  lastSetHomeCard: ReturnType<typeof lastSetHomeCard>;
};

export const homeReducer = combineReducers<HomeReducerState>({
  home,
  cardLimit,
  lastSetHomeSection,
  lastSetHomeCard,
});
